'use client';

import {useContext, useMemo} from 'react';
import {ActiveScreenIdSubscriptionContext} from './ActiveScreenIdProvider';

/**
 * Backwards-compatible single-screen setter. Sets the given id as the sole
 * selected screen, clearing any prior multi-selection. Pass null to clear.
 *
 * For multi-select-aware operations (toggle, append, replace-with-array),
 * use useSetSelectedScreenIds instead.
 */
export function useSetActiveScreenId(): (id: string | null) => void {
  const {setSelectedScreenIds} = useContext(ActiveScreenIdSubscriptionContext);
  return useMemo(
    () => (id: string | null) => {
      setSelectedScreenIds(id === null ? [] : [id]);
    },
    [setSelectedScreenIds],
  );
}
